<section data-component="secondary-banner" class="row justify-content-center align-items-center" #secondaryBanner>
  <div *ngIf = "isAdEnabled; else dynamicAd" class="static-offer">
	<h2>Earn Bean Bucks<sup>sm</sup> on every purchase</h2>
	<div class="ofr-img col-lg-12 col-md-12 col-sm-12">
	<div class="percent gas col-lg-3 col-md-3 col-sm-3"></div>
	<div class="percent llb col-lg-3 col-md-3 col-sm-3"></div>
	<div class="percent res col-lg-3 col-md-3 col-sm-3"></div>
	<div class="percent oth col-lg-3 col-md-3 col-sm-3"></div>
	</div>
	<div class="ofr-txt col-lg-12 col-md-12 col-sm-12">
	<div class="percentTxt col-lg-3 col-md-3 col-sm-3">FREE SHIPPING</div>
	<div class="percentTxt col-lg-3 col-md-3 col-sm-3">FREE RETURN SHIPPING</div>
	<div class="percentTxt col-lg-3 col-md-3 col-sm-3">FREE MONOGRAMMING</div>
	<div class="percentTxt col-lg-3 col-md-3 col-sm-3">NO ANNUAL FEE</div>
	</div>
	</div>
	<ng-template #dynamicAd>
		<span> </span>
	</ng-template>
	
</section>
